export default zip => /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip);
